import {
    type CreateEventResponseType,
    type CreateEventRequestType
} from "./type";
import {
    request
} from "../request";

const CreateEvent = async (params: CreateEventRequestType): Promise<CreateEventResponseType> => {
    return await request<CreateEventResponseType>("/events/createEvent", {
        body: JSON.stringify(params),
        method: "POST"
    });
};

export default CreateEvent;
